$(document).ready () ->
  require 'init'

